module.exports = __webpack_public_path__ + "images/recommend_member_female-c8017440b22d0e67f11a67a7bb55f78c.svg";